import * as React from 'react';
import '../../../panels/panels.css';
import { Button, Label, Segment, Form, Checkbox, Dropdown, Input, Radio } from 'semantic-ui-react';
import axios, { AxiosRequestConfig, AxiosResponse } from 'axios';
import Toast from '../../../sys/toast';
import OAuth, { OAuthClientStatus } from '../../../api';

class State {
    hlsVodCont: boolean; hlsStreamIdReq: boolean; hlsRedirectPlaylist: boolean; hlsRedirectIndex: boolean; hlsRedirectMedia: boolean;
    hlsRedirectKey: boolean; hlsShareConn: boolean; hlsPersistConn: boolean; hlsDecrypt: boolean; hlsDvstMasterTime: boolean;
    hlsCookieMode: boolean; hlsPlaylistGzip: boolean; hlsMediaPlaylistUrlUpdate: boolean; hlsMasterPlaylistRefresh: any;
    hlsVarNameOptBandwidth: boolean; hlsVarNameOptResolution: boolean; hlsVarNameOptAltRendGroupId: boolean; hlsVarNameOptAltRendType: boolean;
    hlsVarNameOptAltRendName: boolean; hlsVarNameOptAltRendLang: boolean; hlsVarNameOptMediaPlaylistName: boolean; hlsVarNameOptEncVarName: boolean;
    hlsAutoStartComp: string; hlsAutoStartCompAllMedia: boolean; hlsAutoStartCompAllAltRendAudio: boolean;
    hlsAutoStartCompAllAltRendSubtitle: boolean; hlsAutoStartCompLimitMedia: boolean; hlsAutoStartCompLimitAltRendAudio: boolean;
    hlsAutoStartCompLimitAltRendSubtitle: boolean; hlsAutoStartCompLimitMediaVar: string; hlsAutoStartCompLimitAltRendAudioVar: string;
    hlsAutoStartCompLimitAltRendSubtitleVar: string; hlsInitReqMode: any; hlsMediaFileStartPos: any; hlsVarNameOptPatternMatch: boolean;
    hlsAutoStartCompNoDup: boolean; hlsMediaFileDurationChkMode: any; hlsDaiEnable: boolean; hlsPersistConnTimeout: any;
    hlsIFrameVariantsEnable: boolean; hlsAutoStartCompAllIFrame: boolean; hlsAutoStartCompLimitIFrame: boolean; hlsAutoStartCompLimitIFrameVar: string;
    hlsVarNameOptIFrameType: boolean; hlsMediaPlaylistDeltaUpdateEnable: boolean;
}

interface Props {

}

export default class AppleStreamingConfig extends React.Component<Props, State> {

    componentWillMount() {
        this.setState({
            hlsVodCont: false, hlsStreamIdReq: false, hlsRedirectPlaylist: false, hlsRedirectIndex: false, hlsRedirectMedia: false,
            hlsRedirectKey: false, hlsShareConn: false, hlsPersistConn: false, hlsDecrypt: false, hlsDvstMasterTime: false,
            hlsCookieMode: false, hlsPlaylistGzip: false, hlsMediaPlaylistUrlUpdate: false, hlsMasterPlaylistRefresh: '',
            hlsVarNameOptBandwidth: false, hlsVarNameOptResolution: false, hlsVarNameOptAltRendGroupId: false,
            hlsVarNameOptAltRendType: false, hlsVarNameOptAltRendName: false, hlsVarNameOptAltRendLang: false,
            hlsVarNameOptMediaPlaylistName: false, hlsVarNameOptEncVarName: false, hlsAutoStartComp: '',
            hlsAutoStartCompAllMedia: false, hlsAutoStartCompAllAltRendAudio: false, hlsAutoStartCompAllAltRendSubtitle: false,
            hlsAutoStartCompLimitMedia: false, hlsAutoStartCompLimitAltRendAudio: false, hlsAutoStartCompLimitAltRendSubtitle: false,
            hlsAutoStartCompLimitMediaVar: '', hlsAutoStartCompLimitAltRendAudioVar: '', hlsAutoStartCompLimitAltRendSubtitleVar: '',
            hlsInitReqMode: '', hlsMediaFileStartPos: '', hlsVarNameOptPatternMatch: false, hlsAutoStartCompNoDup: false, hlsMediaFileDurationChkMode: '',
            hlsDaiEnable: false, hlsPersistConnTimeout: '', hlsIFrameVariantsEnable: false, hlsAutoStartCompAllIFrame: false,
            hlsAutoStartCompLimitIFrame: false, hlsAutoStartCompLimitIFrameVar: '', hlsVarNameOptIFrameType: false, hlsMediaPlaylistDeltaUpdateEnable: false
        });

        this.fetchData();
    }

    fetchData() {
        let _this = this;
        let url = 'http://default/api/config/section/options/abr';
        axios.post(url, {
            mode: 'get',
            defaults: {
            },
            options: [
                'hlsVodCont', 'hlsStreamIdReq', 'hlsRedirectPlaylist', 'hlsRedirectIndex', 'hlsRedirectMedia', 'hlsRedirectKey', 'hlsShareConn',
                'hlsPersistConn', 'hlsDecrypt', 'hlsDvstMasterTime', 'hlsCookieMode', 'hlsPlaylistGzip', 'hlsMediaPlaylistUrlUpdate',
                'hlsMasterPlaylistRefresh', 'hlsVarNameOptBandwidth', 'hlsVarNameOptResolution', 'hlsVarNameOptAltRendGroupId',
                'hlsVarNameOptAltRendType', 'hlsVarNameOptAltRendName', 'hlsVarNameOptAltRendLang', 'hlsVarNameOptMediaPlaylistName',
                'hlsVarNameOptEncVarName', 'hlsAutoStartComp', 'hlsAutoStartCompAllMedia', 'hlsAutoStartCompAllAltRendAudio',
                'hlsAutoStartCompAllAltRendSubtitle', 'hlsAutoStartCompLimitMedia', 'hlsAutoStartCompLimitAltRendAudio',
                'hlsAutoStartCompLimitAltRendSubtitle', 'hlsAutoStartCompLimitMediaVar', 'hlsAutoStartCompLimitAltRendAudioVar',
                'hlsAutoStartCompLimitAltRendSubtitleVar', 'hlsInitReqMode', 'hlsMediaFileStartPos', 'hlsVarNameOptPatternMatch',
                'hlsAutoStartCompNoDup', 'hlsMediaFileDurationChkMode', 'hlsDaiEnable', 'hlsPersistConnTimeout', 'hlsIFrameVariantsEnable',
                'hlsAutoStartCompAllIFrame', 'hlsAutoStartCompLimitIFrame', 'hlsAutoStartCompLimitIFrameVar', 'hlsVarNameOptIFrameType',
                'hlsMediaPlaylistDeltaUpdateEnable'
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.section !== undefined) {
                    let responseObject = response.data.section.options;

                    _this.setState({
                        hlsVodCont: responseObject[0].value, hlsStreamIdReq: responseObject[1].value, hlsRedirectPlaylist: responseObject[2].value,
                        hlsRedirectIndex: responseObject[3].value, hlsRedirectMedia: responseObject[4].value, hlsRedirectKey: responseObject[5].value,
                        hlsShareConn: responseObject[6].value,  hlsPersistConn: responseObject[7].value, hlsDecrypt: responseObject[8].value,
                        hlsDvstMasterTime: responseObject[9].value, hlsCookieMode: responseObject[10].value,
                        hlsPlaylistGzip: responseObject[11].value, hlsMediaPlaylistUrlUpdate: responseObject[12].value,
                        hlsMasterPlaylistRefresh: responseObject[13].value, hlsVarNameOptBandwidth: responseObject[14].value,
                        hlsVarNameOptResolution: responseObject[15].value, hlsVarNameOptAltRendGroupId: responseObject[16].value,
                        hlsVarNameOptAltRendType: responseObject[17].value, hlsVarNameOptAltRendName: responseObject[18].value,
                        hlsVarNameOptAltRendLang: responseObject[19].value, hlsVarNameOptMediaPlaylistName: responseObject[20].value,
                        hlsVarNameOptEncVarName: responseObject[21].value, hlsAutoStartComp: responseObject[22].value,
                        hlsAutoStartCompAllMedia: responseObject[23].value, hlsAutoStartCompAllAltRendAudio: responseObject[24].value,
                        hlsAutoStartCompAllAltRendSubtitle: responseObject[25].value, hlsAutoStartCompLimitMedia: responseObject[26].value,
                        hlsAutoStartCompLimitAltRendAudio: responseObject[27].value, hlsAutoStartCompLimitAltRendSubtitle: responseObject[28].value,
                        hlsAutoStartCompLimitMediaVar: responseObject[29].value, hlsAutoStartCompLimitAltRendAudioVar: responseObject[30].value,
                        hlsAutoStartCompLimitAltRendSubtitleVar: responseObject[31].value, hlsInitReqMode: responseObject[32].value,
                        hlsMediaFileStartPos: responseObject[33].value, hlsVarNameOptPatternMatch: responseObject[34].value,
                        hlsAutoStartCompNoDup: responseObject[35].value, hlsMediaFileDurationChkMode: responseObject[36].value,
                        hlsDaiEnable: responseObject[37].value, hlsPersistConnTimeout: responseObject[38].value, hlsIFrameVariantsEnable: responseObject[39].value,
                        hlsAutoStartCompAllIFrame: responseObject[40].value, hlsAutoStartCompLimitIFrame: responseObject[41].value,
                        hlsAutoStartCompLimitIFrameVar: responseObject[42].value, hlsVarNameOptIFrameType: responseObject[43].value,
                        hlsMediaPlaylistDeltaUpdateEnable: responseObject[44].value

                    });
                } else
                    // tslint:disable-next-line:no-console
                    console.log('expected array of config values, got ', response.data);
            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('fetchData() error: ', error);
            });

    }

    updateConfig(e: any, data: any) {
        //    let _this = this;
        let url = 'http://default/api/config/section/options/abr';

        axios.post(url, {
            mode: 'modify',
            defaults: {
            },
            options: [
                { 'name': 'hlsVodCont', 'value': this.state.hlsVodCont },
                { 'name': 'hlsStreamIdReq', 'value': this.state.hlsStreamIdReq },
                { 'name': 'hlsRedirectPlaylist', 'value': this.state.hlsRedirectPlaylist },
                { 'name': 'hlsRedirectIndex', 'value': this.state.hlsRedirectIndex },
                { 'name': 'hlsRedirectMedia', 'value': this.state.hlsRedirectMedia },
                { 'name': 'hlsRedirectKey', 'value': this.state.hlsRedirectKey },
                { 'name': 'hlsShareConn', 'value': this.state.hlsShareConn },
                { 'name': 'hlsPersistConn', 'value': this.state.hlsPersistConn },
                { 'name': 'hlsDecrypt', 'value': this.state.hlsDecrypt },
                { 'name': 'hlsDvstMasterTime', 'value': this.state.hlsDvstMasterTime },
                { 'name': 'hlsCookieMode', 'value': this.state.hlsCookieMode },
                { 'name': 'hlsPlaylistGzip', 'value': this.state.hlsPlaylistGzip },
                { 'name': 'hlsMediaPlaylistUrlUpdate', 'value': this.state.hlsMediaPlaylistUrlUpdate },
                { 'name': 'hlsMasterPlaylistRefresh', 'value': this.state.hlsMasterPlaylistRefresh },
                { 'name': 'hlsVarNameOptBandwidth', 'value': this.state.hlsVarNameOptBandwidth },
                { 'name': 'hlsVarNameOptResolution', 'value': this.state.hlsVarNameOptResolution },
                { 'name': 'hlsVarNameOptAltRendGroupId', 'value': this.state.hlsVarNameOptAltRendGroupId },
                { 'name': 'hlsVarNameOptAltRendType', 'value': this.state.hlsVarNameOptAltRendType },
                { 'name': 'hlsVarNameOptAltRendName', 'value': this.state.hlsVarNameOptAltRendName },
                { 'name': 'hlsVarNameOptAltRendLang', 'value': this.state.hlsVarNameOptAltRendLang },
                { 'name': 'hlsVarNameOptMediaPlaylistName', 'value': this.state.hlsVarNameOptMediaPlaylistName },
                { 'name': 'hlsVarNameOptEncVarName', 'value': this.state.hlsVarNameOptEncVarName },
                { 'name': 'hlsAutoStartComp', 'value': this.state.hlsAutoStartComp },
                { 'name': 'hlsAutoStartCompAllMedia', 'value': this.state.hlsAutoStartCompAllMedia },
                { 'name': 'hlsAutoStartCompAllAltRendAudio', 'value': this.state.hlsAutoStartCompAllAltRendAudio },
                { 'name': 'hlsAutoStartCompAllAltRendSubtitle', 'value': this.state.hlsAutoStartCompAllAltRendSubtitle },
                { 'name': 'hlsAutoStartCompLimitMedia', 'value': this.state.hlsAutoStartCompLimitMedia },
                { 'name': 'hlsAutoStartCompLimitAltRendAudio', 'value': this.state.hlsAutoStartCompLimitAltRendAudio },
                { 'name': 'hlsAutoStartCompLimitAltRendSubtitle', 'value': this.state.hlsAutoStartCompLimitAltRendSubtitle },
                { 'name': 'hlsAutoStartCompLimitMediaVar', 'value': this.state.hlsAutoStartCompLimitMediaVar },
                { 'name': 'hlsAutoStartCompLimitAltRendAudioVar', 'value': this.state.hlsAutoStartCompLimitAltRendAudioVar },
                { 'name': 'hlsAutoStartCompLimitAltRendSubtitleVar', 'value': this.state.hlsAutoStartCompLimitAltRendSubtitleVar },
                { 'name': 'hlsInitReqMode', 'value': this.state.hlsInitReqMode},
                { 'name': 'hlsMediaFileStartPos', 'value': this.state.hlsMediaFileStartPos },
                { 'name': 'hlsVarNameOptPatternMatch', 'value': this.state.hlsVarNameOptPatternMatch },
                { 'name': 'hlsAutoStartCompNoDup', 'value': this.state.hlsAutoStartCompNoDup},
                { 'name': 'hlsMediaFileDurationChkMode', 'value': this.state.hlsMediaFileDurationChkMode},
                { 'name': 'hlsDaiEnable', 'value': this.state.hlsDaiEnable},
                { 'name': 'hlsPersistConnTimeout', 'value': this.state.hlsPersistConnTimeout},
                { 'name': 'hlsIFrameVariantsEnable', 'value': this.state.hlsIFrameVariantsEnable},
                { 'name': 'hlsAutoStartCompAllIFrame', 'value': this.state.hlsAutoStartCompAllIFrame},
                { 'name': 'hlsAutoStartCompLimitIFrame', 'value': this.state.hlsAutoStartCompLimitIFrame},
                { 'name': 'hlsAutoStartCompLimitIFrameVar', 'value': this.state.hlsAutoStartCompLimitIFrameVar},
                { 'name': 'hlsVarNameOptIFrameType', 'value': this.state.hlsVarNameOptIFrameType},
                { 'name': 'hlsMediaPlaylistDeltaUpdateEnable', 'value': this.state.hlsMediaPlaylistDeltaUpdateEnable}
            ]
        })
            .then(function (response: AxiosResponse) {
                if (response.data !== undefined && response.data.code === 'SUCCESS') {
                    Toast.info('Apple / HTTP Live Streaming configuration applied');
                } else {
                    Toast.error('Apple / HTTP Live Streaming configuration failed');
                }

            })
            .catch(function (error: AxiosRequestConfig) {
                // tslint:disable-next-line:no-console
                console.log('updateConfig() error: ', error);
                Toast.error('Apple / HTTP Live Streaming configuration failed');
            });
    }

    render() {
        const masterPlaylistOptions = [
            { value: 'disabled', text: 'disabled'},
            { value: 60, text: '60 seconds'},
            { value: 300, text: '5 minutes'},
            { value: 900, text: '15 minutes'}
        ];
        const initFileReqModeOptions = [
            { value: 'never', text: 'Never'},
            { value: 'init', text: 'Init'},
            { value: '100', text: '100'},
            { value: '1000', text: '1000'}
        ];
        const mediaFileStartPosOptions = [
            { value: 'auto', text: 'Auto' },
            { value: 'begin', text: 'Begin' },
            { value: 'end', text: 'End' }
        ];
        const hlsMediaFileDurationChkModeOptions = [
            { value: 'ignore', text: 'Ignore' },
            { value: 'warn', text: 'Warn' },
            { value: 'fail', text: 'Fail' }
        ];

        return (
            <OAuth.Context>
                {(oauth: OAuthClientStatus) => {
                    return (
                        <React.Fragment>
                            <div className="assetAliasFilters">
                                <Label className="system-config-pageHeader">
                                    Apple/HTTP Live Streaming
                                </Label>
                                <Button
                                    floated="right"
                                    className="rightButton"
                                    content="Apply"
                                    title="Update Config"
                                    onClick={(e, data) => this.updateConfig(e, data)}
                                />
                            </div>
                            <div className="vertical-flex-main">
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Streaming Options</Segment>
                                <Segment>
                                    <Form>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Play VOD Streams Continuously
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVodCont}
                                                onChange={(e: any, data: any) => this.setState({hlsVodCont: data.checked})}
                                            />
                                        </Form.Group>
                                        : null}
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Include Stream Identifier Cookie In HTTP Requests
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsStreamIdReq}
                                                onChange={(e: any, data: any) => this.setState({hlsStreamIdReq: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Master Playlist Redirect
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsRedirectPlaylist}
                                                onChange={(e: any, data: any) => this.setState({hlsRedirectPlaylist: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Media Playlist Redirect
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsRedirectIndex}
                                                onChange={(e: any, data: any) => this.setState({hlsRedirectIndex: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Media Redirect
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsRedirectMedia}
                                                onChange={(e: any, data: any) => this.setState({hlsRedirectMedia: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Key Redirect
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsRedirectKey}
                                                onChange={(e: any, data: any) => this.setState({hlsRedirectKey: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Shared Media Playlist/Media Connections
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsShareConn}
                                                onChange={(e: any, data: any) => this.setState({hlsShareConn: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped style={{display: 'flex', alignItems: 'center'}}>
                                            <Label className="right-align-label-width500">
                                                Enable Persistent Connections
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsPersistConn}
                                                onChange={(e: any, data: any) => this.setState({hlsPersistConn: data.checked})}
                                            />
                                            <Label className={!this.state.hlsPersistConn ? 'right-align-label-width170 label-disabled' : 'right-align-label-width170'}>
                                                Timeout (seconds)
                                            </Label>
                                                <Input
                                                    className="small-input"
                                                    disabled={!this.state.hlsPersistConn}
                                                    type="number"
                                                    min="0"
                                                    max="600"
                                                    value={this.state.hlsPersistConnTimeout}
                                                    onChange={(e: any, data: any) => this.setState({hlsPersistConnTimeout: data.value})}
                                                />
                                            </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Decryption
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsDecrypt}
                                                onChange={(e: any, data: any) => this.setState({hlsDecrypt: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Include Master Playlist Startup Time In Derived Variant Startup Time
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsDvstMasterTime}
                                                onChange={(e: any, data: any) => this.setState({hlsDvstMasterTime: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Cookies
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsCookieMode}
                                                onChange={(e: any, data: any) => this.setState({hlsCookieMode: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Master/Media Playlist GZIP Compression
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsPlaylistGzip}
                                                onChange={(e: any, data: any) => this.setState({hlsPlaylistGzip: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Media Playlist URL Update
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsMediaPlaylistUrlUpdate}
                                                onChange={(e: any, data: any) => this.setState({hlsMediaPlaylistUrlUpdate: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable Media Playlist Delta Update
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsMediaPlaylistDeltaUpdateEnable}
                                                onChange={(e: any, data: any) => this.setState({hlsMediaPlaylistDeltaUpdateEnable: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Enable I-Frame Variants
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsIFrameVariantsEnable}
                                                onChange={(e: any, data: any) => this.setState({hlsIFrameVariantsEnable: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Master Playlist Refresh
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.hlsMasterPlaylistRefresh}
                                                options={masterPlaylistOptions}
                                                selection
                                                onChange={(event, data) => this.setState({hlsMasterPlaylistRefresh: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Initialization File Request Mode
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.hlsInitReqMode}
                                                options={initFileReqModeOptions}
                                                selection
                                                onChange={(event, data) => this.setState({hlsInitReqMode: data.value})}
                                            />
                                        </Form.Group>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Media File Start Position
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.hlsMediaFileStartPos}
                                                options={mediaFileStartPosOptions}
                                                selection
                                                onChange={(event, data) => this.setState({hlsMediaFileStartPos: data.value})}
                                            />
                                        </Form.Group>
                                        : null}
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Media File Duration Check Mode
                                            </Label>
                                            <Dropdown
                                                search
                                                value={this.state.hlsMediaFileDurationChkMode}
                                                options={hlsMediaFileDurationChkModeOptions}
                                                selection
                                                onChange={(event, data) => this.setState({hlsMediaFileDurationChkMode: data.value})}
                                            />
                                        </Form.Group>
                                        {!oauth.VODOnlyLicensePresent ?
                                        <OAuth.Feature DAI>
                                            <Form.Group grouped>
                                                <Label className="right-align-label-width500">
                                                    Enable Dynamic Ad Insertion
                                                </Label>
                                                <Checkbox
                                                    className="config-checkbox"
                                                    checked={this.state.hlsDaiEnable}
                                                    onChange={(e: any, data: any) => this.setState({hlsDaiEnable: data.checked})}
                                                />
                                            </Form.Group>
                                        </OAuth.Feature>
                                        : null}
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            <Segment.Group className="system-config-segment">
                                <Segment className="segment-header">Variant Name Options</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Pattern Match
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptPatternMatch}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptPatternMatch: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Bandwidth
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptBandwidth}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptBandwidth: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Resolution
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptResolution}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptResolution: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Group Identifier (Alternate Rendition)
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptAltRendGroupId}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptAltRendGroupId: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Type (Alternate Rendition)
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptAltRendType}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptAltRendType: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Name (Alternate Rendition)
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptAltRendName}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptAltRendName: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Language (Alternate Rendition)
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptAltRendLang}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptAltRendLang: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Type (I-Frame)
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptIFrameType}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptIFrameType: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Media Playlist File Name
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptMediaPlaylistName}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptMediaPlaylistName: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Encoder Variant Name
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsVarNameOptEncVarName}
                                                onChange={(e: any, data: any) => this.setState({hlsVarNameOptEncVarName: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                                <Segment className="segment-header">Auto-Start Variant Streams</Segment>
                                <Segment>
                                    <Form>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Disable
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="disabled"
                                                checked={this.state.hlsAutoStartComp === 'disabled'}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartComp: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                All
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="all"
                                                checked={this.state.hlsAutoStartComp === 'all'}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartComp: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hlsAutoStartComp !== 'all')
                                                            ? 'right-align-label-width500-disabled'
                                                            : 'right-align-label-width500'
                                                }
                                            >
                                                Media
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hlsAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompAllMedia}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompAllMedia: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hlsAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Audio Alternative Renditions
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hlsAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompAllAltRendAudio}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompAllAltRendAudio: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hlsAutoStartComp !== 'all')
                                                            ? 'right-align-label-width500-disabled'
                                                            : 'right-align-label-width500'
                                                }
                                            >
                                                Subtitle Alternative Renditions
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hlsAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompAllAltRendSubtitle}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompAllAltRendSubtitle: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hlsAutoStartComp !== 'all')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                I-Frame
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hlsAutoStartComp !== 'all'}
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompAllIFrame}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompAllIFrame: data.checked})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                Limited
                                            </Label>
                                            <Radio
                                                name="radioGroup"
                                                value="limited"
                                                checked={this.state.hlsAutoStartComp === 'limited'}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartComp: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hlsAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Media Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hlsAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompLimitMedia}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitMedia: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitMedia))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.hlsAutoStartCompLimitMediaVar}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitMediaVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hlsAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Audio Alternative Rendition Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hlsAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompLimitAltRendAudio}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitAltRendAudio: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitAltRendAudio))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.hlsAutoStartCompLimitAltRendAudioVar}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitAltRendAudioVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hlsAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                Subtitle Alternative Rendition Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hlsAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompLimitAltRendSubtitle}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitAltRendSubtitle: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitAltRendSubtitle))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.hlsAutoStartCompLimitAltRendSubtitleVar}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitAltRendSubtitleVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label
                                                className={(this.state.hlsAutoStartComp !== 'limited')
                                                    ? 'right-align-label-width500-disabled'
                                                    : 'right-align-label-width500'
                                                }
                                            >
                                                I-Frame Variants
                                            </Label>
                                            <Checkbox
                                                disabled={this.state.hlsAutoStartComp !== 'limited'}
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompLimitIFrame}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitIFrame: data.checked})}
                                            />
                                            <Input
                                                disabled={((this.state.hlsAutoStartComp !== 'limited') || (!this.state.hlsAutoStartCompLimitIFrame))}
                                                maxLength={63}
                                                className="small-input-leftMargin"
                                                value={this.state.hlsAutoStartCompLimitIFrameVar}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompLimitIFrameVar: data.value})}
                                            />
                                        </Form.Group>
                                        <Form.Group grouped>
                                            <Label className="right-align-label-width500">
                                                No Duplicates
                                            </Label>
                                            <Checkbox
                                                className="config-checkbox"
                                                checked={this.state.hlsAutoStartCompNoDup}
                                                onChange={(e: any, data: any) => this.setState({hlsAutoStartCompNoDup: data.checked})}
                                            />
                                        </Form.Group>
                                    </Form>
                                </Segment>
                            </Segment.Group>
                            </div>
                        </React.Fragment>
                    );
                }}
            </OAuth.Context>
        );
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/config/monitoring/appleStreamingConfig.tsx